/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetBranchRequest
 */
export interface SetBranchRequest {
    /**
     * 
     * @type {string}
     * @memberof SetBranchRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SetBranchRequest
     */
    locationId: string;
}

/**
 * Check if a given object implements the SetBranchRequest interface.
 */
export function instanceOfSetBranchRequest(value: object): value is SetBranchRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    return true;
}

export function SetBranchRequestFromJSON(json: any): SetBranchRequest {
    return SetBranchRequestFromJSONTyped(json, false);
}

export function SetBranchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetBranchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'locationId': json['locationId'],
    };
}

  export function SetBranchRequestToJSON(json: any): SetBranchRequest {
      return SetBranchRequestToJSONTyped(json, false);
  }

  export function SetBranchRequestToJSONTyped(value?: SetBranchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'locationId': value['locationId'],
    };
}

